import { Card } from "react-bootstrap"

const RevenueHud = ({ data }: { data: any }) => {
  return (
    <Card
      className="custom-card mb-0 border border-2 border-solid align-items-center"
      style={{ minWidth: 124, width: "fit-content" }}
    >
      <Card.Body className="py-2">
        <div className="d-flex align-items-top">
          <div className="flex-fill">
            <div className="d-flex mb-1 align-items-top justify-content-between">
              <h5 className="fw-semibold mb-0 lh-1">
                {Number(data.revenue.total_revenue).toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </h5>
            </div>
            <p className="mb-0 fs-10 op-7 text-muted fw-semibold text-center">
              Total Revenue
            </p>
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default RevenueHud
